(() => {
  if (customElements.get('atoto-stereo-menu')) return;
  class StereoMenu extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.trigger = this.querySelector('[data-stereo-trigger]');
      this.dialog = this.querySelector('dialog');
      this.scroller = this.querySelector('.stereo-menu__scroll');
      this.back = this.querySelector('[data-stereo-back]');
      this.titleNode = this.querySelector('[data-stereo-title]');
      this.mode = matchMedia('(min-width: 1200px) and (pointer: fine)');
      this.abort = new AbortController();
      const listen = (node, type, fn) => node.addEventListener(type, fn, {signal:this.abort.signal});
      listen(this.trigger, 'click', e => {e.preventDefault(); this.dialog.open ? this.close() : this.open();});
      listen(this.querySelector('[data-stereo-close]'), 'click', () => this.close());
      listen(this.back, 'click', () => this.categories());
      listen(this.dialog, 'cancel', e => {e.preventDefault(); this.close();});
      listen(this.dialog, 'keyup', e => e.stopPropagation());
      listen(this.dialog, 'click', e => {
        if (e.target === this.dialog) {const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();}
        if(e.target.closest('a[data-stereo-destination]')) this.saveReturn();
      });
      this.buttons = [...this.querySelectorAll('[data-stereo-category]')];
      this.panels = [...this.querySelectorAll('[data-stereo-panel]')];
      for (const button of this.buttons) {
        button.hidden = !this.panels.some(p => p.dataset.stereoPanel === button.dataset.stereoCategory);
        listen(button,'click',()=>this.select(button.dataset.stereoCategory,true));
        listen(button,'pointerenter',()=>{if(this.mode.matches){clearTimeout(this.hover);this.hover=setTimeout(()=>this.select(button.dataset.stereoCategory),180);}});
        listen(button,'pointerleave',()=>clearTimeout(this.hover));
      }
      listen(this.dialog,'pointerleave',()=>{if(this.mode.matches)this.leave=setTimeout(()=>this.close(),300);});
      listen(this.dialog,'pointerenter',()=>clearTimeout(this.leave));
      listen(window,'resize',()=>{if(this.dialog.open)this.position();});
      listen(this.mode,'change',()=>{if(this.dialog.open){this.categories();this.position();}});
      listen(window,'pagehide',()=>this.close(false));
      listen(document,'shopify:block:select',e=>{if(this.contains(e.target)){this.open();const p=e.target.closest('[data-stereo-panel]');if(p)this.select(p.dataset.stereoPanel,true);}});
      if(new URLSearchParams(location.search).get('stereo_menu')==='open')this.open();
    }
    disconnectedCallback(){this.close(false);this.abort?.abort();this.ready=false;}
    position(){const bottom=document.querySelector('store-header')?.getBoundingClientRect().bottom||150;this.dialog.style.setProperty('--stereo-top',`${Math.max(0,Math.min(bottom,240))}px`);}
    open(){
      if(this.dialog.open)return;
      const main=this.closest('main-menu');
      main?.nav?.querySelectorAll('details.is-open').forEach(d=>main.close(d));
      if(this.mode.matches)main?.toggleOverlay(false);
      if(typeof removeTrapFocus==='function')removeTrapFocus();
      this.select('all');this.categories();this.position();
      this.trigger.setAttribute('aria-expanded','true');
      document.body.classList.add('stereo-menu-open');this.dialog.showModal();
      this.querySelector('[data-stereo-close]').focus();
    }
    close(focus=true){
      clearTimeout(this.hover);clearTimeout(this.leave);
      if(!this.dialog?.open)return;
      this.dialog.close();document.body.classList.remove('stereo-menu-open');this.trigger.setAttribute('aria-expanded','false');
      if(focus){
        const main=this.closest('main-menu');
        if(!this.mode.matches&&main?.mainDisclosure?.classList.contains('is-open')){
          main.close(main.mainDisclosure,false);main.toggleOverlay(false);main.mainToggle.focus();
        }else this.trigger.focus();
      }
    }
    select(key,focus=false){
      const panel=this.panels.find(p=>p.dataset.stereoPanel===key);if(!panel)return;
      this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.stereoCategory===key)));
      this.panels.forEach(p=>p.hidden=p!==panel);this.active=key;
      if(!this.mode.matches&&focus){this.categoryScroll=this.scroller.scrollTop;this.dialog.dataset.level='content';this.back.hidden=false;this.titleNode.textContent=this.buttons.find(b=>b.dataset.stereoCategory===key).innerText.replace('›','').trim();this.scroller.scrollTop=0;this.back.focus();}
    }
    categories(){this.dialog.dataset.level='categories';this.back.hidden=true;this.titleNode.textContent='Browse car stereos';this.scroller.scrollTop=this.categoryScroll||0;if(this.dialog.open)this.buttons.find(b=>b.dataset.stereoCategory===this.active)?.focus();}
    saveReturn(){
      // Keep a full source snapshot on its own history entry. Global navigation
      // restores only the vehicle against the destination's current catalog.
      const search=document.querySelector('atoto-sbv-live');
      if(!search?.inputs||!['year','make','model'].every(k=>search.valid(k)))return;
      search.persistSelection();const url=new URL(location.href);url.searchParams.set('sbv_restore',JSON.stringify(search.searchSnapshot()));history.replaceState(history.state,'',url);
    }
  }
  customElements.define('atoto-stereo-menu',StereoMenu);
})();
